/*eslint-disable lodash/prefer-lodash-method*/
import negate from 'lodash/negate';
import cmp from '../../lib/cmp';
import selectByClass from '../../lib/dom/select-by-class';
import { addIds, addIndexes } from '../../lib/utils';
import { filterByIphoneScreen, hasWidthAndHeight } from '../../lib/ios-gallery-service';
import bindSubscribingOrInstalling from '../../lib/bind-event-tracking/subscribe-install-btn';
import { mapSmCategory } from '../../lib/categories';
import { TARGET_TYPE } from '../../config/constants';
import template, { INSTALL_BTN_CLASS, INSTALL_BTN_CLASS_STICKY } from './sm-landing-appstore-app-1.template.js';
import './sm-landing-appstore-app-1.less';



const isLandscapeVideoPreview = ({ preview }) => preview.width && preview.height ? preview.width > preview.height : false;
const isPortraitVideoPreview = ({ preview }) => preview.width && preview.height ? preview.width < preview.height : false;

export default cmp(({ experiment }) => {
  const featuredBanner = (experiment.data.featured_page_styles && experiment.data.featured_page_styles.banner && experiment.data.featured_page_styles.banner.url) ? experiment.data.featured_page_styles.banner : null;
  const isiPadExperiment = experiment.target_type === TARGET_TYPE.IPAD;
  const { videos, screenshots } = isiPadExperiment
    ? { videos: experiment.data.videos.filter(({ preview }) => hasWidthAndHeight(preview)), screenshots: experiment.data.screenshots.filter(hasWidthAndHeight) }
    : filterByIphoneScreen(experiment.data.videos, experiment.data.screenshots);

  let _videos = videos.map(addIds);
  let additionalVideos = [];
  const _screenshots = screenshots.map(addIds);

  if (!isiPadExperiment) {
    const isPortraitScreenshots = _screenshots.length > 0 && _screenshots[0].width && _screenshots[0].height && _screenshots[0].width < _screenshots[0].height;

    additionalVideos = isPortraitScreenshots ? _videos.filter(isLandscapeVideoPreview) : _videos.filter(isPortraitVideoPreview);
    _videos = isPortraitScreenshots ? _videos.filter(negate(isLandscapeVideoPreview)) : _videos.filter(negate(isPortraitVideoPreview));
  }

  experiment.data.videos = _videos.map(addIndexes());
  experiment.data.additionalVideos = additionalVideos.map(addIndexes(0));
  experiment.data.screenshots = _screenshots.map(addIndexes(_videos.length)) || [];
  experiment.data.category = mapSmCategory(experiment.data.category);

  if (experiment.data.apple_watch) {
    const _appleWatchScreenshots = (experiment.data.apple_watch.screenshots || []);

    experiment.data.apple_watch.screenshots = _appleWatchScreenshots.map(addIndexes(0)).map(addIds);
  }

  if (experiment.data.apple_tv) {
    const _appleTVScreenshots = (experiment.data.apple_tv.screenshots || []);

    experiment.data.apple_tv.screenshots = _appleTVScreenshots.map(addIndexes(0)).map(addIds);
  }

  return {
    data: experiment.data,
    featuredBanner,
    isIPAD: isiPadExperiment,
    installActionType: experiment.install_action_type
  };
}, template, (element, { installActionType }, component) => {
  bindSubscribingOrInstalling(selectByClass(element, INSTALL_BTN_CLASS), installActionType, component);
  bindSubscribingOrInstalling(selectByClass(element, INSTALL_BTN_CLASS_STICKY), installActionType, component, { label: 'sticky-head' });
});



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1/sm-landing-appstore-app-1.js